var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0504 9.70057C24.5713 8.94316 23.5808 8.69065 22.7822 9.13267C21.9835 9.60592 21.7598 10.6158 22.2391 11.4047C23.3573 13.2036 23.9003 15.3493 23.6766 17.6529C23.1975 22.5125 19.1404 26.3625 14.2208 26.7096C8.24695 27.1199 3.26346 22.3864 3.32735 16.58C3.3913 11.1837 7.8636 6.70282 13.3263 6.60815H13.3902V9.00638C13.3902 9.70063 14.157 10.1424 14.7638 9.76379L21.3126 5.72457C21.8875 5.37744 21.8875 4.55704 21.3126 4.20992L14.7957 0.139024C14.1887 -0.239585 13.4222 0.202199 13.4222 0.896435V3.32634C5.65943 3.38951 -0.537993 9.89008 0.0370252 17.6845C0.516116 24.2167 5.8511 29.4866 12.4638 29.96C20.3863 30.5596 26.999 24.3429 26.999 16.6432C27.0309 14.1186 26.2962 11.7204 25.0503 9.70074L25.0504 9.70057Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.38c2aede3759d1424abf23e3de4a76c7.svg";
export { ForwardRef as ReactComponent };